module.exports = __webpack_public_path__ + "static/media/TRIAL 3-if-wrong-after-10-sec.c24968b6.mp3";